import "./Pricing.css";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import InputGroup from "react-bootstrap/InputGroup";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDollarSign } from "@fortawesome/free-solid-svg-icons";
import Instance from "../../Utils/Axios";
import { showToast } from "../../Utils";
import Loader from "../Loader/PremiumLoader";
import { BuyPrModal } from "../Modal/customModal";

const Payment = () => {
  const [packageDetails, setPackageDetails] = useState(null);
  const [profileDetails, setProfileDetails] = useState({});
  const [originalProfileDetails, setOriginalProfileDetails] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [loading, setLoading] = useState(true);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);

  const { id } = useParams();
  const navigate = useNavigate();

  const fetchProfileDate = () => {
    const token = localStorage.getItem("tokenId");
    if (!token) return;

    Instance.post("/user/details", { /* tokenId: token */ })
      .then((response) => {
        setProfileDetails(response?.data?.userProfile || {});
        setOriginalProfileDetails(response?.data?.userProfile || {});
      })
      .catch((error) => {
        console.error("Error fetching the profile details", error);
      });
  };

  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setProfileDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (validationErrors[name]) {
      setValidationErrors((prev) => ({
        ...prev,
        [name]: null
      }));
    }
  };

  const fetchPackageData = () => {
    const token = localStorage.getItem("tokenId");
    if (!token || !id) {
      navigate("/customer/dashboard");
      return;
    }

    Instance.post("/user/package/details", {
      // tokenId: token,
      packageId: id,
    })
      .then((response) => {

        if (response.data.resCode !== "200") {

          // ❗ API message show karo
          showToast(response.data.resMessage, "error", "error");

          setPackageDetails(null);
          return;
        }

        const data = response.data.message;
        setPackageDetails(data && typeof data === "object" ? data : null);

      })
      .catch((error) => {
        console.error("error fetching the package details", error);
        setPackageDetails(null);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchProfileDate();
    fetchPackageData();
  }, []);

  const handleApplyCoupon = async () => {
    if (couponCode.trim()) {
      try {
        const response = await Instance.post("/user/coupon/validate", {
          packageId: id,
          couponCode: couponCode.trim(),
        });

        if (response.data.resCode === "200") {
          setAppliedCoupon({
            code: couponCode.trim(),
            discountAmount: response.data.discountAmount,
            finalPrice: response.data.finalPrice,
          });
          setCouponCode("");
          showToast(response.data.resMessage || "Coupon applied successfully", "success", "success");
        } else {
          showToast(response.data.resMessage || "Failed to apply coupon", "error", "error");
        }
      } catch (error) {
        console.error("Error applying coupon", error);
        showToast("Error applying coupon", "error", "error");
      }
    }
  };

  const handleRemoveCoupon = () => {
    setAppliedCoupon(null);
  };

  const handleSubmit = async () => {
    const token = localStorage.getItem("tokenId");
    const PNR = localStorage.getItem("superPNR");

    if (!token || !PNR) {
      showToast("Session information missing", "error", "error");
      return;
    }

    const errors = {};
    if (!profileDetails.firstName) errors.firstName = "First Name is required";
    if (!profileDetails.lastName) errors.lastName = "Last Name is required";
    if (!profileDetails.country) errors.country = "Country is required";
    if (!profileDetails.address) errors.address = "Address is required";
    if (!profileDetails.mobile) errors.mobile = "Mobile No. is required";
    if (!profileDetails.email) errors.email = "Email is required";

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }
    setValidationErrors({});

    let isProfileChanged = false;
    const fieldsToCheck = ["firstName", "lastName", "country", "address", "mobile", "email"];
    for (const field of fieldsToCheck) {
      if (profileDetails[field] !== originalProfileDetails[field]) {
        isProfileChanged = true;
        break;
      }
    }

    if (isProfileChanged) {
      try {
        const updateRes = await Instance.post("/user/updateUser", {
          ...originalProfileDetails,
          ...profileDetails
        });
        if (updateRes.data.resCode !== "200") {
          showToast(updateRes.data.resMessage || "Failed to update user profile", "error", "error");
          return;
        }
      } catch (err) {
        console.error("Error updating profile", err);
        showToast("Error updating user profile", "error", "error");
        return;
      }
    }

    Instance.post("/user/credit/purchase", {
      // tokenId: token,
      superPNR: PNR,
      couponCode: appliedCoupon ? appliedCoupon.code : "",
    })
      .then((response) => {
        if (response.data.resCode === "200") {
          setTimeout(() => {
            navigate(`/customer/payment_method/${id}`, {
              state: { packageDetails, appliedCoupon }
            });
          }, 1000);
        } else {
          showToast(response.data.resMessage, "error", "error");
        }
      })
      .catch((error) => {
        console.error("cannot proceed ahead!", error);
        setShowFailureModal(true);
      });
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <div className="credit_payment_layout">
        <div className="payment_steps">
          <div className="d-flex payment_step_item completed">
            <div className="paymeny_step_img completed_step">
              <img src="/build/greycart.png" alt="Browse Packages" />
            </div>
            <div className="steps_detail">
              <h5>Browse Packages</h5>
              <p>Step 1</p>
            </div>
          </div>
          <div className="d-flex payment_step_item active">
            <div className="paymeny_step_img active_step">
              <img src="/build/whitetruck.png" alt="Billing Info" />
            </div>
            <div className="steps_detail">
              <h5>Billing Info</h5>
              <p>Step 2</p>
            </div>
          </div>

          <div className="d-flex payment_step_item">
            <div className="paymeny_step_img ">
              <img src="/build/greypayment.png" alt="Payment Methods" />
            </div>
            <div className="steps_detail">
              <h5>Payment Methods</h5>
              <p>Step 3</p>
            </div>
          </div>
          <div className="d-flex payment_step_item">
            <div className="paymeny_step_img">
              <img src="/build/greyaward.png" alt="Confirmation" />
            </div>
            <div className="steps_detail">
              <h5>Confirmation</h5>
              <p>Step 4</p>
            </div>
          </div>
        </div>

        <div className="billing_details">
          <div className="package_details">
            <h4 className="billing_title">Choose Package</h4>

            {packageDetails ? (
              <>
                <div className="package_name">
                  <h5>{packageDetails.packageName || "n/a"}</h5>
                  <p>{packageDetails.validity || ""} Days</p>
                </div>
                <div className="package_info">
                  <h5>Package Information</h5>
                  <p>Package Validity is :- {packageDetails.validity ? `${packageDetails.validity} Days` : "NA"}</p>
                  <p>No of credits is :- {packageDetails.pressReleaseCount ?? "NA"}</p>
                </div>
                <div className="package_pricing">
                  <p>{packageDetails.packageName || "n/a"}</p>
                  <span><span className="currency_symbol"><FontAwesomeIcon icon={faDollarSign} /></span>{packageDetails.price || "0"}</span>
                </div>
                <div className="package_pricing">
                  <p>Discount</p>
                  <span style={{ color: "#22c55e", fontWeight: "600" }}>
                    {appliedCoupon ? <>- <span className="currency_symbol"><FontAwesomeIcon icon={faDollarSign} /></span>{appliedCoupon.discountAmount}</> : ""}
                  </span>
                </div>
                <div className="pricing_total">
                  <p>Total</p>
                  <span><span className="currency_symbol"><FontAwesomeIcon icon={faDollarSign} /></span>{appliedCoupon ? appliedCoupon.finalPrice : (packageDetails.price || "0")}</span>
                </div>
              </>
            ) : (
              <div className="package-not-available-box">
                <div className="not-available-content">
                  <h5>Package Details Not Available</h5>
                  <p>We're unable to load the selected package right now.</p>
                  <small>Please go back and try selecting the package again, or contact support if the issue persists.</small>
                </div>
              </div>
            )}

            <div className="mb-3 d-flex flex-column gap-2">
              <div className="d-flex gap-2 align-items-center">
                <Form.Control
                  placeholder="Enter a valid coupon code"
                  aria-label="coupon"
                  value={couponCode}
                  onChange={(e) => setCouponCode(e.target.value)}
                />
                <button
                  className="coupon_apply_btn"
                  onClick={handleApplyCoupon}
                  disabled={!!appliedCoupon || !couponCode.trim()}
                >
                  Apply
                </button>
              </div>
              {appliedCoupon && (
                <div
                  className="applied_coupon_box d-flex justify-content-between align-items-center p-2 rounded"
                  style={{ backgroundColor: "#f0fdf4", border: "1px dashed #22c55e", color: "#15803d" }}
                >
                  <div className="d-flex align-items-center gap-2" style={{ wordBreak: "break-word", overflowWrap: "break-word", paddingRight: "10px" }}>
                    <span className="fw-medium">Coupon <strong>{appliedCoupon.code}</strong> applied!</span>
                  </div>
                  <button
                    className="btn btn-sm text-danger p-0 text-decoration-none fw-medium"
                    onClick={handleRemoveCoupon}
                    style={{ flexShrink: 0 }}
                  >
                    Remove
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="shipping_details">
            <h4 className="billing_title">Shipping Details</h4>
            <Form>
              <h4>User Information</h4>

              <Row>
                <Col className="custom_col_sub_account mb-4">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    placeholder="Enter First Name"
                    name="firstName"
                    value={profileDetails.firstName || ""}
                    readOnly={!!originalProfileDetails.firstName}
                    onChange={handleProfileChange}
                    isInvalid={!!validationErrors.firstName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {validationErrors.firstName}
                  </Form.Control.Feedback>
                </Col>
                <Col className="custom_col_sub_account mb-4">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    placeholder="Enter Last Name"
                    name="lastName"
                    value={profileDetails.lastName || ""}
                    readOnly={!!originalProfileDetails.lastName}
                    onChange={handleProfileChange}
                    isInvalid={!!validationErrors.lastName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {validationErrors.lastName}
                  </Form.Control.Feedback>
                </Col>
              </Row>
              <Row>
                <Col className="custom_col_sub_account mb-4">
                  <Form.Label>Country</Form.Label>
                  <Form.Control
                    placeholder="Enter Country"
                    name="country"
                    value={profileDetails.country || ""}
                    readOnly={!!originalProfileDetails.country}
                    onChange={handleProfileChange}
                    isInvalid={!!validationErrors.country}
                  />
                  <Form.Control.Feedback type="invalid">
                    {validationErrors.country}
                  </Form.Control.Feedback>
                </Col>
                <Col className="custom_col_sub_account mb-4">
                  <Form.Label>Address</Form.Label>
                  <Form.Control
                    placeholder="Enter Address"
                    name="address"
                    value={profileDetails.address || ""}
                    readOnly={!!originalProfileDetails.address}
                    onChange={handleProfileChange}
                    isInvalid={!!validationErrors.address}
                  />
                  <Form.Control.Feedback type="invalid">
                    {validationErrors.address}
                  </Form.Control.Feedback>
                </Col>
              </Row>
              <Row>
                <Col className="custom_col_sub_account mb-4">
                  <Form.Label>Mobile No.</Form.Label>
                  <Form.Control
                    placeholder="Enter Mobile Number"
                    name="mobile"
                    value={profileDetails.mobile || ""}
                    readOnly={!!originalProfileDetails.mobile}
                    onChange={handleProfileChange}
                    isInvalid={!!validationErrors.mobile}
                  />
                  <Form.Control.Feedback type="invalid">
                    {validationErrors.mobile}
                  </Form.Control.Feedback>
                </Col>
                <Col className="custom_col_sub_account mb-4">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    placeholder="Enter Email"
                    name="email"
                    value={profileDetails.email || ""}
                    readOnly={!!originalProfileDetails.email}
                    onChange={handleProfileChange}
                    isInvalid={!!validationErrors.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {validationErrors.email}
                  </Form.Control.Feedback>
                </Col>
              </Row>
            </Form>
          </div>

          <div className="package_buy_btns">
            <Link to="/customer/pricing">
              <button className="back_btn">Go Back</button>
            </Link>
            <button
              className="pay_btn"
              onClick={handleSubmit}
              disabled={!packageDetails}
            >
              Proceed to Pay
            </button>
          </div>
        </div>
      </div>
      <BuyPrModal
        show={showFailureModal}
        onClose={() => setShowFailureModal(false)}
        onClick={() => {
          setShowFailureModal(false);
          handleSubmit();
        }}
        onSecondaryClick={() => {
          setShowFailureModal(false);
          navigate(`/customer/payment_method/${id}`, {
            state: { packageDetails, appliedCoupon }
          }); // Redirect to payment methods
        }}
        title="Payment Failed!"
        message="Your transaction could not be processed. Please check your payment details or try again."
        primaryBtn="Retry Payment"
        secondaryBtn="Saved Payment Methods"
      />
    </>
  );
};

export default Payment;